import React, { Component } from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  SmallestBody,
  StandardBody,
} from 'web-ui-components/lib/typography/body';
import {
  SubsectionHeading,
  SubHeading,
} from 'web-ui-components/lib/typography/headings';
import InternetBankingActions from '../../actions/InternetBankingActions';
import StepHeader from '../../includes/StepHeader';
import AccountsStore from '../../stores/AccountsStore/AccountsStore';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';

export class ManageInsurance extends Component {
  constructor(props) {
    super(props);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.state = {
      showModal: false,
      toggleModalLink: false,
    };
  }
  handleBackButton() {
    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
  }
  continue(e) {
    e.preventDefault();
    this.setState({ showModal: false });
    const { toggleModalLink } = this.state;
    window.open(
      toggleModalLink
        ? 'https://uk.virginmoney.com/vmforms/current-accounts/club-m-account/turn-off-insurance/'
        : 'https://uk.virginmoney.com/vmforms/current-accounts/club-m-account/turn-on-insurance/'
    );
  }
  getModalHeading = () => {
    const { content } = this.props;
    return (
      <p>
        <strong>{content.modalHeading}</strong>
      </p>
    );
  };
  getModalBody = () => {
    const { content } = this.props;
    return (
      <div>
        <p>{content.HelpPopupContent1}</p>
        <p>{content.HelpPopupContent2}</p>
      </div>
    );
  };
  getModalFooter = () => {
    const { content } = this.props;
    return (
      <div className="button-group">
        <NavigationButton.Secondary
          labelText={content.cancelButtonText}
          onClick={() => this.setState({ showModal: false })}
        />
        <NavigationButton.Primary
          labelText={content.continueButtonText}
          onClick={(e) => this.continue(e)}
        />
      </div>
    );
  };

  render() {
    const { content } = this.props;
    const accountId = AccountsStore.getAccount();
    const accDetails = AccountsStore.getAccountDetail(accountId);
    const { code } = accDetails?.product;
    const isClubMwithInsurance = code === '755';
    return (
      <div className="page bow manage-insurance-page">
        <div
          id="site-main"
          className="container mb-20"
          role="main"
          tabIndex="-1"
        >
          <div className="row">
            <div className="col-md1-18">
              {
                <StepHeader
                  showheaderCrumbs
                  headerCrumbsMessage={content.back}
                  headerTitle={content.manageInsuranceLandingPageHeader}
                  onClick={this.handleBackButton}
                />
              }
            </div>
          </div>
          <StandardBody>
            {!isClubMwithInsurance && (
              <p>
                <strong>{content.manageInsuranceSubText}</strong>
              </p>
            )}
            <p>
              {isClubMwithInsurance
                ? content.manageInsuranceText1
                : content.manageInsuranceText2}
            </p>
          </StandardBody>
          <ul>
            <li>{content.manageInsuranceOption1}</li>
            <li>{content.manageInsuranceOption2}</li>
            <li>{content.manageInsuranceOption3}</li>
          </ul>
          <SubsectionHeading>
            {isClubMwithInsurance
              ? content.manageInsuranceMessage
              : content.manageInsuranceInfoText}
          </SubsectionHeading>
        </div>
        <div className={`container ${isClubMwithInsurance ? 'pb-0' : 'pb-30'}`}>
          {isClubMwithInsurance ? (
            <div>
              <SubHeading>{content.manageInsuranceTurnOffText}</SubHeading>
              <StandardBody>
                <p>{content.manageInsuranceHelpText1}</p>
                <p>{content.manageInsuranceHelpText2}</p>
                <p className="mb-20">{content.manageInsuranceMessage1}</p>
              </StandardBody>
              <NavigationButton.Secondary
                labelText={content.manageInsuranceTurnOffButtonText}
                onClick={() =>
                  this.setState({ showModal: true, toggleModalLink: true })
                }
              />
            </div>
          ) : (
            <div>
              <SubHeading>{content.manageInsuranceTurnOnText}</SubHeading>
              <StandardBody>
                <p>{content.manageInsuranceHelpText3}</p>
                <p className="mb-24">{content.manageInsuranceHelpText4}</p>
              </StandardBody>
              <NavigationButton.Primary
                labelText={content.manageInsuranceTurnOnButtonText}
                onClick={() =>
                  this.setState({ showModal: true, toggleModalLink: false })
                }
              />
            </div>
          )}
        </div>
        <PatternLibModalComponent
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          bsSize={'medium'}
          modalHeading={this.getModalHeading()}
          modalBody={this.getModalBody()}
          modalFooter={this.getModalFooter()}
          customClass={'c-modal'}
        />
      </div>
    );
  }
}
